import { UseQueryResult } from "@tanstack/react-query";
import { createContext } from "react";

import { GetReportByIdQuery } from "@api/graphql/types-and-hooks";

export type ReportNode = NonNullable<
  NonNullable<NonNullable<GetReportByIdQuery["getReports"]>["edges"][number]>["node"]
>;

// How a Report's content is surfaced: "single" combines the parts on one page
// (e.g. Diagnosis Evaluation under db-single-page); "step" splits them across
// separate wizard steps. Drives report-field action availability.
export type ReportViewMode = "single" | "step";

export interface ReportDataI {
  report: ReportNode;
  reportQuery: UseQueryResult<GetReportByIdQuery, unknown>;
  viewMode: ReportViewMode;
}

export const ReportContext = createContext<ReportDataI | undefined>(undefined);
